import React, { useState } from 'react';
import Slider from 'react-slick';
import { format } from 'date-fns';
import '../../../styles/CalenderSlider.css';

type CalendarSlider = {
  customClass?: string;
  isLoading?: boolean;
  redirectToBus?: (completeDate) => void;
};

type DatesToShow = {
  id: number;
  date: string;
  festival?: string;
  completeDate?: string;
};

const CalenderSlider = ({ customClass = '', isLoading = false, redirectToBus }: CalendarSlider) => {
  const calenderSliderSettings = {
    dots: false,
    vertical: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 8,
    adaptiveHeight: true
  };
  const [select, setSelect] = useState(-1);

  const date = new Date();

  const handleClick = (item) => {
    setSelect(item.index);
    if (redirectToBus) redirectToBus(item.completeDate);
  };

  const datesToShow: DatesToShow[] = [];
  for (let i = 0; i <= 8; i++) {
    date.setDate(date.getDate() + 1);
    datesToShow.push({ id: i, date: format(date, 'D MMM'), completeDate: format(date, 'DD-MM-YYYY') });
  }

  return (
    <div className={`calSlider ${customClass}`}>
      <Slider {...calenderSliderSettings}>
        {isLoading
          ? new Array(9).fill(0).map((_, idx) => (
              <div key={idx} className="shimmerState">
                <p className="smallLoader appendTop15 appendLeft10 appendRight10"></p>
                <p className="smallLoader appendLeft10 appendRight10"></p>
              </div>
            ))
          : datesToShow &&
            datesToShow.map((item, index) => (
              <div
                key={item.id}
                onClick={() => handleClick(item)}
                className={`otherItm ${select === index ? 'activeItm' : ''}`}
              >
                {item.festival && <span className="font10 festivalTag lineHeight16">{item.festival}</span>}
                {item.date && <span className="font12 lineHeight16 appendBottom2">{item.date}</span>}
              </div>
            ))}
      </Slider>
    </div>
  );
};

export default CalenderSlider;
